import React, { useContext, useEffect, useState } from "react";
import { store } from "store.js";
import Loading from "components/Loading";
import Cookies from "universal-cookie";
import userInfo from "core/api/userInfo/userInfoApi";
import { DTUserSession } from "core/Utils/Dynatrace";
import { useHistory } from "react-router-dom";
import { getUrlParams } from "core/Utils/getUrlParams";
import * as Origin from "core/Utils/Origin";
import Analytics from "core/Utils/Analytics";
import { getDomainName } from "core/Utils";

export default function UserInfo(props) {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const [isLoading, setIsLoading] = useState(true);
  const [modalContent, setModalContent] = useState(null);
  const logoutLink = process.env.REACT_APP_PING_AUTHORIZE;
  const history = useHistory();
  const origin = getUrlParams('origin');

  useEffect(function () {
    checkUserData();
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cookies = new Cookies();
  let accesstoken = "";
  async function checkUserData() {
    setIsLoading(true);
    let result = await userInfo();
    accesstoken = cookies.get("accesstoken");
    let { error = null } = result;
    
    if (!accesstoken || error) {
      try {
        window.localStorage.setItem("pathToRedirect", window.location.pathname+window.location.search);
      } catch (e) {}
     
      if (process.env.REACT_APP_AMBIENTE !== "local")
      {
     
        window.location.href = logoutLink;
    }
    } else {
      dispatch({
        type: "SET_ACCESS_TOKEN",
        payload: accesstoken,
      });
      dispatch({
        type: "SET_USER_DATA",
        payload: result,
      });
      Analytics().setEvent({
        eventAction: "conversion",
        eventCategory: "claro-id",
        eventLabel: "claro-id",
        event: "conversion",
        dimension1: `${result.claroId}`,
      });
      setIsLoading(false);

      try {
        const pathToRedirect = window.localStorage.getItem("pathToRedirect");
        if (pathToRedirect) {
          history.push(pathToRedirect);
          window.localStorage.removeItem("pathToRedirect");
        }
      } catch (e) {}
      DTUserSession(result.documentId || result.customerId);
    }

    if(origin) {
      if(Origin.exists(origin)){
        window.sessionStorage.setItem("origin", origin);
      }
    }
  }

  function onRequestClose(data = {}) {
    setModalContent(null);
  }

  if(isLoading) return <Loading isLoading={isLoading} />
  return (
    <>
      {props.children}
    </>
  );
}
